import { API, graphqlOperation } from "aws-amplify";

export interface ProjectOpenRouterGroupConfig {
  id: string;
  openrouterStandardGroupModels?: string | null;
  openrouterPremiumGroupModels?: string | null;
  standardGroupModels?: string | null;
  premiumGroupModels?: string | null;
}

const getProjectOpenRouterGroupsQuery = /* GraphQL */ `
  query GetProjectOpenRouterGroups($id: ID!) {
    getLLMProject(id: $id) {
      id
      openrouterStandardGroupModels
      openrouterPremiumGroupModels
      standardGroupModels
      premiumGroupModels
    }
  }
`;

export async function fetchProjectOpenRouterGroups(
  id: string
): Promise<ProjectOpenRouterGroupConfig | null> {
  const response = (await API.graphql(
    graphqlOperation(getProjectOpenRouterGroupsQuery, { id })
  )) as {
    data?: {
      getLLMProject?: ProjectOpenRouterGroupConfig | null;
    };
  };

  return response?.data?.getLLMProject || null;
}
